import { Component } from 'react'
import PropTypes from 'prop-types'

import InputTextField from 'components/common/InputTextField'
import Button from 'components/common/Button'

export default class CompanyName extends Component {
  static propTypes = {
    email: PropTypes.string,
    companyName: PropTypes.string,
    submitForm: PropTypes.func,
    handleChange: PropTypes.func
  }

  render() {
    return (
      <div className="formFields">
        <InputTextField
          label="Company Name"
          name="name"
          value={this.props.companyName}
          onChange={this.props.handleChange}
        />
        <Button
          data-test-submit-company-name
          stretch
          disabled={!this.props.companyName.length}
          type="submit"
        >
          <span>Continue</span>
        </Button>
      </div>
    )
  }
}
